<template>
  <div class="soil-detail pa-3">
    <div class="caption text--secondary">
      {{ selectedObservatory.address }}
    </div>
    <div class="caption text--secondary mb-1">
      {{ selectedObservatory.lat }}, {{ selectedObservatory.lng }}
    </div>

    <v-btn-toggle v-model="displayItem" mandatory dense class="mb-2">
      <v-btn small value="VWC">
        体積含水率
      </v-btn>
      <v-btn small value="PF">
        PF値
      </v-btn>
      <v-btn small value="Temperature">
        温度
      </v-btn>
      <v-btn small value="All">
        全て
      </v-btn>
    </v-btn-toggle>

    <v-btn-toggle v-model="displayInterval" mandatory dense class="mb-2">
      <v-btn small :value="10">
        10分毎
      </v-btn>
      <v-btn small :value="60">
        時間毎
      </v-btn>
      <v-btn small :value="24">
        24時間毎
      </v-btn>
    </v-btn-toggle>

    <template v-if="isDeficit">
      <div class="mt-5 caption">データが存在しません。</div>
    </template>

    <template v-else>
      <SoilChart
        :height="240"
        :timeSeries="timeSeries"
        :displayItem="displayItem"
        :displayInterval="displayInterval"
      />

      <v-simple-table dense class="mt-1">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">日時</th>
              <th class="text-center">体積含水率</th>
              <th class="text-center">PF値</th>
              <th class="text-center">温度</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ts, index) in timeSeries" :key="index">
              <td>{{ ts.tabeleDate }}</td>
              <td class="text-center">
                {{ ts.VWC === null ? "-" : ts.VWC.toFixed(3) }}
              </td>
              <td class="text-center">
                {{ ts.PF === null ? "-" : ts.PF.toFixed(1) }}
              </td>
              <td class="text-center">
                {{ ts.Temperature === null ? "-" : ts.Temperature.toFixed(1) }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
import SoilChart from "./SoilChart";
import moment from "moment";

export default {
  name: "SoilDetail",
  components: { SoilChart },
  data() {
    return {
      displayItem: "VWC",
      displayInterval: 10
    };
  },
  computed: {
    selectedObservatory() {
      return this.$store.getters.selectedObservatory;
    },
    currentDate() {
      const baseDate = this.$store.getters.baseDate.clone();
      return baseDate.subtract(baseDate.minute() % 10, "minutes");
    },
    isDeficit() {
      return this.timeSeries.length === 0;
    },
    timeSeries() {
      const start = this.currentDate.clone();
      if (this.displayInterval === 10) {
        start.subtract(3, "hours");
      } else if (this.displayInterval === 60) {
        start.subtract(2, "days");
      } else {
        start.subtract(14, "days");
      }
      const displayStartTime = start.format("YYYY/MM/DD HH:mm");
      const displayLimitTime = this.currentDate.format("YYYY/MM/DD HH:mm");
      return this.selectedObservatory.timeSeries
        .filter(
          r =>
            r.date > displayStartTime &&
            r.date <= displayLimitTime &&
            (this.displayInterval === 10 ||
              (this.displayInterval === 60 && r.date.substr(-2) === "00") ||
              (this.displayInterval === 24 && r.date.substr(-5) === "15:00"))
        )
        .map(r => {
          const d = moment.utc(r.date, "YYYY/MM/DD HH:mm").local();
          return {
            tabeleDate: d.format("MM/DD HH:mm"),
            chartDate: d.toDate(),
            PF: r.PF !== undefined ? r.PF : null,
            Temperature: r.Temperature !== undefined ? r.Temperature : null,
            VWC: r.VWC !== undefined ? r.VWC : null
          };
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.soil-detail {
  thead {
    background-color: #addff3;
  }
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
  .std-color {
    width: 16px;
    height: 12px;
    border-bottom: white 3px solid;
  }
  .predict {
    color: blue;
  }
}
</style>
